module.exports = __webpack_public_path__ + "4c3bdbc6aebd3edf9f2733eeee900c20.png";